import { FC } from 'react'
import { useRouter } from 'next/router'
import { useGetDesignServices } from '@/client/hooks'
import { OrdersRoot } from './OrdersRoot'
import { IMyAccount } from './types'

export const MyDesignServices: FC<IMyAccount> = ({ header, footer, content }) => {
  const { query } = useRouter()
  const { data, isLoading } = useGetDesignServices(query.state)
  return (
    <OrdersRoot header={header} footer={footer} content={content} isService isLoading={isLoading} orders={data || []} />
  )
}
